/**
 * Gets the input token address from a route array.
 * @param {Array} route - The route array from getRoute response
 *   Each step object must contain a tokenIn property.
 *
 * @returns {string|undefined} The input token address or undefined if route is invalid
 *   - Returns in token contract address for valid routes
 *
 * @example
 * // Example 1: Get input token for SEI -> USDC route
 * const route = await getRoute({
 *   tokenIn: "0x0", // SEI
 *   tokenOut: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48", // USDC
 *   amountIn: '1'
 * });
 * const tokenIn = getTokenIn(route);
 * console.log(tokenIn); // "0xe30fedd158a2e3b13e9badaeabafc5516e95e8c7"
 * @note This function returns WSEI address for native SEI input too. getRouteDetails function handles SEI inputs but this function does not. Careful when using externally.
 */
export const getTokenIn = (route) => {
  if (!route || !Array.isArray(route)) {
    console.error("Invalid or missing `route`: Must be an array.");
    return undefined;
  }
  return route[0][0].tokenIn.toLowerCase();
};
